<template>
  <TransitionFadeSlideUp>
    <div v-if="airport" class="popup relative bg-white shadow-xl rounded-lg px-5 py-4 flex flex-col items-start"
         style="width: 280px;">
      <p class="font-bold font-header text-grey-500 text-base">{{ airport.name }}</p>


      <ul class="mt-2 flex items-center flex-wrap">
        <li
            v-for="tag in airportTags" :key="tag.label"
            class="mr-4 py-px rounded-full text-xs font-medium whitespace-no-wrap flex items-center"
            :class="[`text-${tag.type}`]"
        >
          <div class="w-2 h-2 bg-current rounded-full mr-1.5"></div>
          <span>{{ tag.label }}</span>
        </li>
      </ul>


      <div class="mt-5 flex items-center">
        <SvgJetLanding class="h-6 text-gray-400"/>
        <p class="ml-auto text-grey-400 font-medium text-sm">{{ airport.icao_code }}</p>
      </div>
    </div>
  </TransitionFadeSlideUp>
</template>

<script>
import {getAirport} from '@/services/api'
import TransitionFadeSlideUp from '@/components/transitions/FadeSlideUp'
import SvgJetLanding from '@/components/svg/JetLanding'

export default {
  components: {TransitionFadeSlideUp, SvgJetLanding},
  props: {
    id: {type: Number, required: true},
  },
  data() {
    return {
      airport: null,
    }
  },
  computed: {
    airportTags() {
      if (this.airport === null) {
        return []
      }

      if (
          this.airport.jetfly_pc12_operability === 'operable'
          && this.airport.jetfly_pc24_operability === 'operable'
          && this.airport.jetfly_sf50_operability === 'operable'
      ) {
        return [
          {type: 'success', label: 'PC-12, PC-24 & SF50 Operable'},
        ]
      }

      if (
          this.airport.jetfly_pc12_operability === 'unoperable'
          && this.airport.jetfly_pc24_operability === 'unoperable'
          && this.airport.jetfly_sf50_operability === 'unoperable'
      ) {
        return [
          {type: 'danger', label: 'PC-12, PC-24 & SF50 Unoperable'},
        ]
      }

      if (
          this.airport.jetfly_pc12_operability === 'restricted'
          && this.airport.jetfly_pc24_operability === 'restricted'
          && this.airport.jetfly_sf50_operability === 'restricted'
      ) {
        return [
          {type: 'warning', label: 'PC-12, PC-24 & SF50 Restricted'},
        ]
      }

      let airportTags = [];

      if (this.airport.jetfly_pc12_operability === 'operable') {
        airportTags.push({type: 'success', label: 'PC-12 Operable'})
      }

      if (this.airport.jetfly_pc12_operability === 'unoperable') {
        airportTags.push({type: 'danger', label: 'PC-12 Unoperable'})
      }

      if (this.airport.jetfly_pc12_operability === 'restricted') {
        airportTags.push({type: 'warning', label: 'PC-12 Restricted'})
      }

      if (this.airport.jetfly_pc24_operability === 'operable') {
        airportTags.push({type: 'success', label: 'PC-24 Operable'})
      }

      if (this.airport.jetfly_pc24_operability === 'unoperable') {
        airportTags.push({type: 'danger', label: 'PC-24 Unoperable'})
      }

      if (this.airport.jetfly_pc24_operability === 'restricted') {
        airportTags.push({type: 'warning', label: 'PC-24 Restricted'})
      }

      if (this.airport.jetfly_sf50_operability === 'operable') {
        airportTags.push({type: 'success', label: 'SF50 Operable'})
      }

      if (this.airport.jetfly_sf50_operability === 'unoperable') {
        airportTags.push({type: 'danger', label: 'SF50 Unoperable'})
      }

      if (this.airport.jetfly_sf50_operability === 'restricted') {
        airportTags.push({type: 'warning', label: 'SF50 Restricted'})
      }

      return airportTags;
    }
  },
  async mounted() {
    const {data} = await getAirport(this.id)
    this.airport = data
  }
}
</script>

<style scoped>
.popup::after {
  content: '';
  top: 100%;
  border-top: solid 10px #fff;
  border-left: solid 12px transparent;
  border-right: solid 12px transparent;
  @apply absolute w-0 h-0 my-0 mx-auto inset-x-0
}

</style>
